import type React from "react";
import { BiBuilding, BiFile, BiStore } from "react-icons/bi";
import { RiLinksLine } from "react-icons/ri";

import { useTranslation } from "src/design-system/core/TranslationContext";
import { useIntercom } from "src/hooks/useIntercom";
import { ORGANIZATION_LAYOUT_TK } from "src/layouts/OrganizationLayout/config";
import { SideMenuAWithNavBarLayout } from "src/layouts/SideMenuWithNavBarLayout/SideMenuWithNavBarLayout";
import { ORGANIZATION_TRANSLATION_NAMESPACE } from "src/views/organization/config";
import { organizationRoutes } from "src/views/organization/routes";

import _ from "lodash";
import { useAuth } from "src/hooks";
import type { NavBarSection } from "../SharedLayout/NavBar";

interface OrganizationLayoutProps {
    children?: React.ReactNode;
}

function OrganizationLayout({ children }: OrganizationLayoutProps): JSX.Element {
    useIntercom();
    const { t } = useTranslation(`${ORGANIZATION_TRANSLATION_NAMESPACE}:${ORGANIZATION_LAYOUT_TK}`);
    const { userAdminId } = useAuth();
    const isAdmin = userAdminId !== undefined;

    const allItems = [
        {
            title: t("organizations"),
            icon: BiBuilding,
            href: organizationRoutes.detailsView(),
            order: 0,
            isAdmin: false,
        },
        {
            title: t("pos"),
            icon: BiStore,
            href: organizationRoutes.possView(),
            order: 1,
            isAdmin: false,
        },
        {
            title: t("invoices"),
            icon: BiFile,
            href: organizationRoutes.invoicesListView(),
            order: 2,
            isAdmin: false,
        },
        {
            title: t("tools"),
            icon: RiLinksLine,
            href: organizationRoutes.externalToolsView(),
            order: 3,
            isAdmin: false,
        },
    ];

    const sections: NavBarSection[] = [
        {
            items: _.orderBy(
                allItems.filter((i) => !i.isAdmin || isAdmin),
                ["order"],
                ["asc"]
            ),
        },
    ];
    return <SideMenuAWithNavBarLayout sections={sections}>{children}</SideMenuAWithNavBarLayout>;
}

export default OrganizationLayout;
